import { connect } from 'react-redux';
import { StoreState } from '../../../reducers';

import ThemedItemEditor from '../../../components/Editor/ThemedItemEditor';

interface ThemedItemEditorOwnProps {
	page: number;
	id: string;
}

const mapStateToProps = (state: StoreState, { page, id }: ThemedItemEditorOwnProps) => {
	const {
		editor: {
			activeItem,
			editPanel: { isDisplayed: isEditPanelDisplayed },
		},
	} = state;

	return {
		isActive: id === activeItem.id && page === activeItem.page,
		isEditPanelDisplayed,
	};
};

export default connect(mapStateToProps)(ThemedItemEditor);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/ThemedItemEditor/index.tsx